import { Api } from './Api'

class Login {
  post (params) {
    const body = {
      id: params.customerId,
      code: params.code,
      data: {
        customerId: params.customerId,
        siteId: params.siteId
      }
    }
    return fetch(Api.getBaseUrl() + 'login/', Api.getOptions('POST', body))
  }

  get () {
    return fetch(Api.getBaseUrl() + 'login/', Api.getOptions())
  }
}

export default Login
